import { getSessionUUID } from '../components/lib/AuthToken'; // Import the utility function
import logger from "../utils/logger";


export const fetch_all_holidays = async (range) => {
    
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ range }),
        };

        // Send Request to backend
        const response = await fetch('/holidays/get_holidays_by_range', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error fetching holidays:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};


//-------------------------------------------------------------------------------------------------


export const use_add_new_holiday = async (holiday_data) => {

    try{
        // User input
        const body = {
            holiday_data
        };

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend
        const response = await fetch('/holidays/add_new_holiday', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };

    } catch (err) {
        logger.error("Error adding holiday:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};


//-------------------------------------------------------------------------------------------------


export const use_delete_holiday = async (holiday_id) => {

    try{
        // User input
        const body = {
            holiday_id
        };

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend
        const response = await fetch('/holidays/delete_holiday', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };

    } catch (err) {
        logger.error("Error deleting holiday:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};


//-------------------------------------------------------------------------------------------------


export const use_update_holiday = async (holiday_data) => {

    try{
        // User input
        const body = {
            holiday_data
        };

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend
        const response = await fetch('/holidays/update_holiday', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };

    } catch (err) {
        logger.error("Error updating holiday:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};


export const delete_holiday_by_user_date = async (user_id, date) => {
    try {
        const sessionToken = await getSessionUUID();
        
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ user_id, date }),
        };

        const response = await fetch('/holidays/delete_holiday_by_user_date', requestOptions);
        const responseBody = await response.json();

        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null,
        };

    } catch (err) {
        logger.error("Error deleting holiday by user and date:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};


export const find_holiday_by_user_date = async (user_id, date) => {
    try {
        const sessionToken = await getSessionUUID();
        
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ user_id, date }),
        };

        const response = await fetch('/holidays/find_holiday_by_user_date', requestOptions);
        const responseBody = await response.json();

        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null,
        };

    } catch (err) {
        logger.error("Error finding holiday by user and date:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};